import $api from "@/assets/js/api.js";
import $router from "@/router";
import $errors from "@/assets/js/errors.js";
import axios from "axios";

const state = {
  currentImport: null,
  imports: {},
  currentImportRows: {},
  currentErrorRow: null,
};

const getters = {
  import_get_current_import: (state) => {
    return state.currentImport;
  },
  import_get_current_import_rows: (state) => {
    return state.currentImportRows;
  },
  import_get_imports: (state) => {
    return state.imports.data;
  },
  import_get_imports_meta: (state) => {
    return state.imports.meta;
  },
  import_get_current_import_error_row: (state) => {
    return state.currentErrorRow;
  },
};

const mutations = {
  IMPORT_SET_IMPORTS(state, imports) {
    state.imports = imports;
  },
  IMPORT_SET_CURRENT_IMPORT(state, currentImport) {
    state.currentImport = currentImport;
  },
  IMPORT_SET_IMPORT_ROWS(state, currentImportRows) {
    state.currentImportRows = currentImportRows;
  },
  IMPORT_SET_CURRENT_ERROR_ROW(state, currentImportErrorRow) {
    state.currentErrorRow = currentImportErrorRow;
  },
};

const actions = {
  getImport({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      console.log("get Import");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamImportsImportGet(params)
            .then((res) => {
              console.log("teamImportsImportGet", res.data.data);
              commit("IMPORT_SET_CURRENT_IMPORT", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          console.log("get Import Err");
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getImportColumnTemplate({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamImportsColumnsTemplateGet(params)
            .then((res) => {
              console.log("teamImportsColumnsTemplateGet", res.data);
              axios
                .get(res.data.data.redirect, {})
                .then((response) => {
                  commit("GLOBAL_LOADING_ENDED");
                  resolve(response);
                })
                .catch((err) => {
                  commit("GLOBAL_LOADING_ENDED");
                  reject(err);
                });
            })
            .catch((err) => {
              console.log(">>>>>>>>>>>>>>> Download ERROR", err);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          console.log("err", err);
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getImportErrors({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "updated_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "DESC",
        search: payload.params.search ? payload.params.search : "",
        import: payload.import,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamImportsImportErrorsGet(params)
            .then((res) => {
              console.log("teamImportsImportErrorsGet", res.data);
              commit("IMPORT_SET_IMPORT_ROWS", res.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          console.log("err", err);
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getImportError({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamImportsImportErrorsErrorGet(params)
            .then((res) => {
              console.log("teamImportsImportErrorsErrorGet", res.data.data);
              commit("IMPORT_SET_CURRENT_ERROR_ROW", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          console.log("error error get", err);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getImports({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "updated_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "DESC",
        search: payload.params.search ? payload.params.search : "",
        import_type: "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          console.log("params", params);
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamImportsGet(params)
            .then((res) => {
              console.log("teamClientsImportsGet", res.data);
              commit("IMPORT_SET_IMPORTS", res.data);
              if (payload.setListsSettings) {
                console.log("whut", res);
                commit("GLOBAL_SET_LISTS_SETTINGS", {
                  list: "imports",
                  pagination: {
                    page: res.data.meta.pagination.current_page,
                    perPage: res.data.meta.pagination.per_page,
                    lastPage: res.data.meta.pagination.last_page,
                    total: res.data.meta.pagination.total,
                  },
                  order: {
                    col: params.order_col,
                    dir: params.order_dir,
                  },
                  search: params.search,
                  filter: {},
                });
              }
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  createImport({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      dispatch("prepareRequest", {})
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamImportsPost(params, payload.data)
            .then((res) => {
              console.log("teamClientsImportPost", res);
              params.import = res.data.data.uid;
              params.file = res.data.data.file.uid;
              axios
                .put(res.data.data.upload_request.request_url, payload.data.file, {
                  headers: {
                    "Content-Type": payload.data.mime_type,
                  },
                })
                .then((res) => {
                  console.log(">>>>>>>>>>>>>>> UPLOADED SUCCCSFULLY TO S3", res);
                  dispatch("createImportComplete", params)
                    .then((res) => {
                      commit("GLOBAL_LOADING_ENDED");
                      resolve(res);
                    })
                    .catch((err) => {
                      commit("GLOBAL_LOADING_ENDED");
                      reject(err);
                    });
                })
                .catch((err) => {
                  console.log(">>>>>>>>>>>>>>> S3 UPLOAD ERROR", err);
                  commit("GLOBAL_LOADING_ENDED");
                  reject(err);
                });
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  createImportComplete({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamImportsImportFileCompletePost(params)
            .then((res) => {
              console.log("teamImportsImportFileCompletePost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
